$(document).ready(function() {
  $('.newsletter-signup__button').magnificPopup({
    type: 'inline',
    preloader: false,
    focus: '.newsletter-popup'
  });
  
  const headerHeight = () => {
    const pageHero = document.getElementsByClassName("page-hero")[0];
    const pageHeroText = document.getElementsByClassName("page-hero__text-wrap")[0];
    const wholeHeader = document.getElementsByClassName("header-wrapper")[0];
    
    pageHero && !pageHeroText && (pageHero.style.minHeight = wholeHeader.offsetHeight + "px");
    pageHeroText && (pageHeroText.style.paddingTop = wholeHeader.offsetHeight + "px");
  };
  
  headerHeight();
  window.addEventListener("resize", headerHeight);
  
  const collectionFilterInitiate = collectionFilter => {
    const filterForm = collectionFilter.getElementsByClassName("collection__filter-form")[0];
    const currentHost = filterForm?.dataset.host;
    const currentPath = filterForm?.getAttribute("action");
    
    filterForm && filterForm.addEventListener("submit", event => {
      event.preventDefault();
      const currentForm = event.currentTarget;
      const formData = new FormData(currentForm);
      const currentTags = "/" + Array.from(formData.keys()).join("+");
      const newUrl = currentHost + currentPath + currentTags;
      
      window.location.replace(newUrl)
      
    });
  };
  
  const collectionFilter = document.getElementsByClassName("collection__filter")[0];
  
  collectionFilter && collectionFilterInitiate(collectionFilter);
});
